// Tools data for the About page tools section
// Add new tools by creating objects with the following structure:
// {
//     id: unique_number,
//     name: "Tool Name",
//     category: "Category (e.g., 'Development', 'Design', 'Analytics', etc.)",
//     logoPath: "path/to/logo.png", // Optional - can be added later
//     description: "Brief description of how you use this tool", // Optional
//     showItem: true // Set to false to hide from display
// }

let ToolsData = [
    // Data & Analytics
    {
        id: 1,
        name: "Google Cloud",
        category: "Data & Analytics",
        logoPath: require('../Images/Logos/GoogleCloud.png'),
        description: "Cloud computing and services",
        showItem: true
    },
    {
        id: 2,
        name: "BigQuery",
        category: "Data & Analytics",
        logoPath: require('../Images/Logos/BigQuery.png'),
        description: "Cloud data warehouse and analytics",
        showItem: true
    },
    {
        id: 3,
        name: "Looker",
        category: "Data & Analytics",
        logoPath: require('../Images/Logos/Looker.png'),
        description: "Business intelligence and data exploration",
        showItem: true
    },
    {
        id: 4,
        name: "Google Analytics",
        category: "Data & Analytics",
        logoPath: require('../Images/Logos/GoogleAnalytics.png'),
        description: "Web analytics and reporting platform",
        showItem: true
    },
    {
        id: 5,
        name: "PostgreSQL",
        category: "Data & Analytics",
        logoPath: require('../Images/Logos/PostgreSQL.png'),
        description: "Relational database management",
        showItem: true
    },
    {
        id: 6,
        name: "Tableau",
        category: "Data & Analytics",
        logoPath: require('../Images/Logos/Tableau.png'),
        description: "Data visualization and business intelligence",
        showItem: true
    },
    {
        id: 7,
        name: "Alteryx",
        category: "Data & Analytics",
        logoPath: require('../Images/Logos/Alteryx.png'),
        description: "Data preparation and analytics",
        showItem: true
    },
    {
        id: 8,
        name: "Supabase",
        category: "Data & Analytics",
        logoPath: require('../Images/Logos/Supabase.png'),
        description: "Open source Firebase alternative",
        showItem: true
    },
    {
        id: 9,
        name: "AWS",
        category: "Data & Analytics",
        logoPath: require('../Images/Logos/AWS.png'),
        description: "Cloud infrastructure and services",
        showItem: true
    },

    // AI & Automation
    {
        id: 10,
        name: "ChatGPT",
        category: "AI & Automation",
        logoPath: require('../Images/Logos/ChatGPT.png'),
        description: "AI-powered conversational assistant",
        showItem: true
    },
    {
        id: 11,
        name: "n8n",
        category: "AI & Automation",
        logoPath: require('../Images/Logos/n8n.png'),
        description: "Workflow automation platform",
        showItem: true
    },
    {
        id: 12,
        name: "Claude",
        category: "AI & Automation",
        logoPath: require('../Images/Logos/Claude.png'),
        description: "Anthropic's AI assistant",
        showItem: true
    },
    {
        id: 13,
        name: "Gemini",
        category: "AI & Automation",
        logoPath: require('../Images/Logos/Gemini.png'),
        description: "Google's AI models and platform",
        showItem: true
    },
    {
        id: 14,
        name: "Vertex AI",
        category: "AI & Automation",
        logoPath: require('../Images/Logos/Vertex.png'),
        description: "Google's machine learning platform",
        showItem: true
    },
    {
        id: 15,
        name: "Zapier",
        category: "AI & Automation",
        logoPath: require('../Images/Logos/Zapier.png'),
        description: "App integration and automation",
        showItem: true
    },
    {
        id: 16,
        name: "Perplexity",
        category: "AI & Automation",
        logoPath: require('../Images/Logos/Perplexity.png'),
        description: "AI-powered search and research",
        showItem: true
    },
    {
        id: 17,
        name: "Bolt",
        category: "AI & Automation",
        logoPath: require('../Images/Logos/Bolt.png'),
        description: "Business operations platform",
        showItem: true
    },

    // Programming
    {
        id: 18,
        name: "JavaScript",
        category: "Programming",
        logoPath: require('../Images/Logos/JavaScript.png'),
        description: "Core web development language",
        showItem: true
    },
    {
        id: 19,
        name: "React/Next.js",
        category: "Programming",
        logoPath: require('../Images/Logos/React.png'),
        description: "Modern frontend frameworks",
        showItem: true
    },
    {
        id: 20,
        name: "HTML5/CSS",
        category: "Programming",
        logoPath: require('../Images/Logos/HTML.png'),
        description: "Web markup and styling",
        showItem: true
    },
    {
        id: 21,
        name: "Ruby on Rails",
        category: "Programming",
        logoPath: require('../Images/Logos/RubyOnRails.png'),
        description: "Full-stack web development",
        showItem: true
    },
    {
        id: 22,
        name: "Python",
        category: "Programming",
        logoPath: require('../Images/Logos/Python.png'),
        description: "Data analysis and backend development",
        showItem: true
    },
    {
        id: 23,
        name: "Git",
        category: "Programming",
        logoPath: require('../Images/Logos/Git.png'),
        description: "Version control system",
        showItem: true
    },
    {
        id: 24,
        name: "Copilot",
        category: "Programming",
        logoPath: require('../Images/Logos/Copilot.png'),
        description: "AI pair programming assistant",
        showItem: true
    },
    {
        id: 25,
        name: "Cursor",
        category: "Programming",
        logoPath: require('../Images/Logos/Cursor.png'),
        description: "AI-powered code editor",
        showItem: true
    },

    // BizOps
    {
        id: 26,
        name: "Salesforce",
        category: "BizOps",
        logoPath: require('../Images/Logos/Salesforce.png'),
        description: "CRM and business platform",
        showItem: true
    },
    {
        id: 27,
        name: "HubSpot",
        category: "BizOps",
        logoPath: require('../Images/Logos/HubSpot.png'),
        description: "Marketing and sales platform",
        showItem: true
    },
    {
        id: 28,
        name: "Sheets/Excel",
        category: "BizOps",
        logoPath: require('../Images/Logos/Sheets.png'),
        description: "Spreadsheet and data analysis",
        showItem: true
    },
    {
        id: 29,
        name: "Apollo",
        category: "BizOps",
        logoPath: require('../Images/Logos/Apollo.png'),
        description: "Sales intelligence platform",
        showItem: true
    },
    {
        id: 30,
        name: "Zoom",
        category: "BizOps",
        logoPath: require('../Images/Logos/Zoom.png'),
        description: "Video conferencing platform",
        showItem: true
    },
    {
        id: 31,
        name: "Gong",
        category: "BizOps",
        logoPath: require('../Images/Logos/Gong.png'),
        description: "Revenue intelligence platform",
        showItem: true
    }
];

export { ToolsData };